import type { ColumnVisibilityItem } from "providers/Auth";
import { mergeSavedColumns } from "shared/utils/column-order";
import { DEFAULT_COLUMN_VISIBILITY } from "../constants";

export const mergeColumnsWithDefaults = (
  savedColumns: ColumnVisibilityItem[] | undefined
): ColumnVisibilityItem[] =>
  mergeSavedColumns(savedColumns, DEFAULT_COLUMN_VISIBILITY);
